export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="mb-8">
    <ol className="flex flex-wrap items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-sand">
      <li>
        <a href="/" data-testid="breadcrumb-home-link" className="transition-colors hover:text-cheddar">
          Beranda
        </a>
      </li>
      {items.map((it, i) => (
        <li key={it.label} className="flex items-center gap-2">
          <span aria-hidden="true" className="text-white/20">
            /
          </span>
          {i === items.length - 1 ? (
            <span className="text-cream" aria-current="page">
              {it.label}
            </span>
          ) : (
            <a href={it.href} className="transition-colors hover:text-cheddar">
              {it.label}
            </a>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
